import { ArrowsClockwise, ChartLineUp } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { AREA_META, useAppData, AreaCardShell, KpiChip, MultiSeriesChart } from "./AppDataParts";

export const WebappDataSection = () => {
  const { data, refreshing, refresh } = useAppData("/admin/apps/analisi");
  const areas = data?.areas || [];
  const connected = areas.filter((a) => a.status === "connected" && a.data);
  const chartLines = connected
    .flatMap((a) => (a.data.series || []).map((s) => ({
      label: `${AREA_META[a.area].name} — ${s.label}`,
      color: AREA_META[a.area].color,
      points: s.points || [],
    })))
    .slice(0, 8);

  return (
    <div data-testid="monitor-webapp-section">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <p className="text-sm text-slate-400 max-w-2xl">
          KPI e andamenti raccolti automaticamente dalle webapp collegate ({connected.length}/{areas.length} collegate).
        </p>
        <Button data-testid="apps-refresh-button" onClick={refresh} disabled={refreshing}
          variant="ghost" className="h-10 px-5 border border-white/20 text-white hover:bg-white/5 hover:text-white rounded-full text-xs font-semibold">
          <ArrowsClockwise size={15} className={`mr-1.5 ${refreshing ? "animate-spin" : ""}`} /> {refreshing ? "Aggiornamento..." : "Aggiorna ora"}
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8">
        {areas.map((a) => (
          <AreaCardShell key={a.area} area={a.area} status={a.status} error={a.error}
            updatedAt={a.updated_at} testId={`analisi-card-${a.area}`} endpointHint="/api/paq/metrics">
            {(a.data?.kpis || []).length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                {(a.data.kpis || []).slice(0, 6).map((k) => <KpiChip key={k.key || k.label} kpi={k} />)}
              </div>
            ) : (
              <p className="text-xs text-white/40">Collegata ma nessun KPI esposto.</p>
            )}
          </AreaCardShell>
        ))}
      </div>

      <div className="p-8 rounded-lg bg-surface border border-surface-border animate-fade-up" data-testid="analisi-cross-card">
        <h2 className="font-heading text-2xl font-semibold tracking-tight mb-1">Grafici incrociati</h2>
        <p className="text-sm text-slate-400 mb-4">Le serie storiche esposte dalle webapp, sovrapposte per un confronto immediato.</p>
        {chartLines.length > 0 ? (
          <MultiSeriesChart lines={chartLines} />
        ) : (
          <div className="py-8 text-center" data-testid="analisi-cross-empty">
            <ChartLineUp size={38} weight="duotone" className="text-white/25 mx-auto mb-3" />
            <p className="text-sm text-white/40 max-w-md mx-auto">
              Nessuna serie storica ancora: appena una webapp esporrà i propri dati, il grafico comparirà qui automaticamente.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
